import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, RouterOutlet } from '@angular/router';
import { GlobalsService } from '@shared/services/globals.service';
import { filter, map, mergeMap } from 'rxjs';
import { FullLoaderComponent } from './shared/components/loaders/full-loader/full-loader.component';
import { TitleService } from './shared/services/title.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, FullLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'base';

  constructor(
    public globals: GlobalsService,
    private titleService: TitleService,
    private activatedRoute: ActivatedRoute
  ) {
    this.globals.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((r) => {
          while (r.firstChild) r = r.firstChild;
          return r;
        }),
        mergeMap((r) => r.data)
      )
      .subscribe((data) => {
        if (data['title']) {
          this.titleService.setTitle(data['title']);
        } else {
          this.titleService.setTitle(
            'Kreador Business Suite | Kreador, your business in all in one platform'
          );
        }
      });
  }
}
